export const testimonials = [
  {
    id: 1,
    company: "BICEA Uganda",
    service: "Website Creation",
    location: "Buvuma, Uganda",
    name: 'Mr Katamba Philly',
    role: 'CEO, ',
    avatar: 'https://res.cloudinary.com/dspsj31q8/image/upload/v1761120413/bicea-logo_mtwtox.jpg',
    rating: 4,
    text: 'BientoMart transformed our online presence completely. Their team built us a BUVUMA ISLANDS COMMUNITY EMPOWERMENT ASSOCIATION platform that increased our Prisence by 300% in just three months. Highly professional and responsive!',
  },
  {
    id: 2,
    company: "HashiHive Company Ltd",
    service: "Website Creation",
    location: "Kigali, Rwanda",
    name: 'Hashim Nshimiyimana',
    role: 'Founder, ',
    avatar: 'https://res.cloudinary.com/dbtchmsoy/image/upload/v1757926236/WhatsApp_Image_2025-09-15_at_10.14.08_AM_foul42.jpg',
    rating: 5,
    text: 'Working with BientoMart was a game-changer for our construction Company. They understood our vision and delivered a website that perfectly represents our brand. .',
  },
  {
    id: 3,
    company: "Vimatec LTD",
    service: "Website Creation",
    location: "Kampala, Uganda",
    name: 'Mr Marthin',
    role: 'Marketing Director,',
    avatar: 'https://res.cloudinary.com/dspsj31q8/image/upload/v1769682349/last-vim-logo_c4sctl.jpg',
    rating: 5,
    text: 'The social media management services from BientoMart have been exceptional. Our engagement rates have tripled, and we are seeing real business results. They truly understand digital marketing.',
  },
  {
    id: 4,
    company: " Heaven Community Patyway",
    service: "Website Creation",
    location: "Kabowa, Uganda",
    name: 'Leonard Kapita Manukinina',
    role: 'CEO,',
    avatar: 'https://ui-avatars.com/api/?name=Leonard+Kapita&background=0D2340&color=ffffff&size=150',
    rating: 5,
    text: 'BientoMart created a Heaven Community Pathway platform that exceeded all our expectations.  advanced search features have made us stand out.',
  },
];
